import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-d-flex p-ai-center p-mt-2" }
const _hoisted_2 = { class: "p-d-flex p-flex-row p-col-5" }
const _hoisted_3 = {
  for: "startDate",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_4 = { class: "p-error p-grid" }
const _hoisted_5 = { class: "p-col-12" }
const _hoisted_6 = { class: "p-col-4 p-d-flex p-ai-center" }
const _hoisted_7 = {
  for: "startTime",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_8 = { class: "p-d-flex p-ai-center  p-mt-3" }
const _hoisted_9 = { class: "p-d-flex p-flex-row p-col-5" }
const _hoisted_10 = {
  for: "endDate",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_11 = { class: "p-error p-grid" }
const _hoisted_12 = { class: "p-col-12" }
const _hoisted_13 = {
  key: 0,
  class: "p-col-6 p-d-flex p-ai-center"
}
const _hoisted_14 = {
  for: "endTime",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_15 = { class: "p-d-flex p-flex-row" }
const _hoisted_16 = { class: "p-d-flex p-flex-row p-mt-5" }
const _hoisted_17 = { class: "p-d-flex p-flex-row p-mr-4" }
const _hoisted_18 = { class: "kn-material-input-label p-m-2" }
const _hoisted_19 = { class: "p-error" }
const _hoisted_20 = { class: "p-col-12" }
const _hoisted_21 = {
  key: 0,
  class: "p-d-flex p-flex-row"
}
const _hoisted_22 = {
  for: "parameter",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_23 = {
  key: 1,
  class: "p-d-flex p-flex-row p-m-2"
}
const _hoisted_24 = { class: "p-m-1" }
const _hoisted_25 = {
  key: 2,
  class: "p-d-flex p-flex-row"
}
const _hoisted_26 = { class: "p-m-2" }
const _hoisted_27 = { class: "p-mr-2" }
const _hoisted_28 = {
  key: 0,
  class: "p-d-flex p-flex-row p-mt-2"
}
const _hoisted_29 = {
  for: "parameterMonth",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_30 = {
  for: "parameterMonth",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_31 = {
  key: 1,
  class: "p-d-flex p-flex-row p-mt-2"
}
const _hoisted_32 = { class: "kn-material-input-label p-m-2" }
const _hoisted_33 = { class: "p-m-2" }
const _hoisted_34 = { class: "p-mr-2" }
const _hoisted_35 = {
  key: 0,
  class: "p-d-flex p-flex-row p-mt-2"
}
const _hoisted_36 = {
  for: "parameterDay",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_37 = {
  key: 1,
  class: "p-d-flex p-flex-row p-mt-2"
}
const _hoisted_38 = {
  for: "parameterDay",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_39 = {
  for: "parameterDay",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_40 = {
  key: 3,
  for: "parameter",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_41 = {
  key: 4,
  for: "parameter",
  class: "kn-material-input-label p-m-2"
}
const _hoisted_42 = {
  key: 5,
  for: "parameter",
  class: "kn-material-input-label p-m-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    style: _ctx.knCronDescriptor.style.cardContainer
  }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('cron.startDate') + ':'), 1),
          _createVNode("span", null, [
            _createVNode(_component_Calendar, {
              id: "startDate",
              class: ["kn-material-input", {
                                'p-invalid': !_ctx.validDates
                            }],
              style: _ctx.knCronDescriptor.style.calendarInput,
              modelValue: _ctx.startDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.startDate = $event)),
              showIcon: true,
              manualInput: true,
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setDate('startDate'))),
              onDateSelect: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setDate('startDate')))
            }, null, 8, ["style", "modelValue", "class"]),
            _withDirectives(_createVNode("div", _hoisted_4, [
              _createVNode("small", _hoisted_5, _toDisplayString(_ctx.$t('kpi.kpiScheduler.dateError')), 1)
            ], 512), [
              [_vShow, !_ctx.validDates]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('cron.startTime') + ':'), 1),
          _createVNode("span", null, [
            _createVNode(_component_Calendar, {
              id: "startTime",
              style: _ctx.knCronDescriptor.style.timePicker,
              class: "kn-material-input custom-timepicker",
              modelValue: _ctx.startTime,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.startTime = $event)),
              manualInput: true,
              timeOnly: true,
              hourFormat: "24",
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setDate('startDate'))),
              onDateSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setDate('startDate')))
            }, null, 8, ["style", "modelValue"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('cron.endDate') + ':'), 1),
          _createVNode("span", null, [
            _createVNode(_component_Calendar, {
              id: "endDate",
              class: ["kn-material-input p-ml-2", {
                                'p-invalid': !_ctx.validDates
                            }],
              style: _ctx.knCronDescriptor.style.calendarInput,
              modelValue: _ctx.endDate,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.endDate = $event)),
              showIcon: true,
              manualInput: true,
              showButtonBar: true,
              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setDate('endDate'))),
              onDateSelect: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setDate('endDate'))),
              onClearClick: _ctx.clearEndDate
            }, null, 8, ["style", "modelValue", "class", "onClearClick"]),
            _withDirectives(_createVNode("div", _hoisted_11, [
              _createVNode("small", _hoisted_12, _toDisplayString(_ctx.$t('kpi.kpiScheduler.dateError')), 1)
            ], 512), [
              [_vShow, !_ctx.validDates]
            ])
          ])
        ]),
        (_ctx.endDate)
          ? (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('cron.endTime') + ':'), 1),
              _createVNode("span", null, [
                _createVNode(_component_Calendar, {
                  id: "endTime",
                  style: _ctx.knCronDescriptor.style.timePicker,
                  class: "kn-material-input p-ml-2 custom-timepicker",
                  modelValue: _ctx.endTime,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.endTime = $event)),
                  manualInput: true,
                  timeOnly: true,
                  hourFormat: "24",
                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setDate('endDate'))),
                  onDateSelect: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setDate('endDate')))
                }, null, 8, ["style", "modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_15, [
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('cron.repeatInterval') + ':') + " *", 1),
            _createVNode("span", null, [
              _createVNode(_component_Dropdown, {
                id: "repeatInterval",
                class: ["kn-material-input", { 'p-error': !_ctx.validInterval }],
                style: _ctx.knCronDescriptor.style.intervalInput,
                optionLabel: "name",
                optionValue: "value",
                modelValue: _ctx.repeatInterval,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.repeatInterval = $event)),
                options: _ctx.knCronDescriptor.intervals,
                onChange: _ctx.updateCronInterval
              }, null, 8, ["class", "style", "modelValue", "options", "onChange"]),
              _withDirectives(_createVNode("div", _hoisted_19, [
                _createVNode("small", _hoisted_20, _toDisplayString(_ctx.$t('cron.repeatInterval') + ' is required!'), 1)
              ], 512), [
                [_vShow, !_ctx.validInterval]
              ])
            ])
          ]),
          (_ctx.repeatInterval === 'minute' || _ctx.repeatInterval === 'hour' || _ctx.repeatInterval === 'day')
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('kpi.kpiScheduler.every')), 1),
                _createVNode("span", null, [
                  _createVNode(_component_Dropdown, {
                    id: "parameter",
                    class: "kn-material-input",
                    optionLabel: "name",
                    optionValue: "value",
                    modelValue: _ctx.parameter,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.parameter = $event)),
                    options: _ctx.parameterOptions,
                    onChange: _ctx.updateCronNumberOfRepetition
                  }, null, 8, ["modelValue", "options", "onChange"])
                ])
              ]))
            : (_ctx.repeatInterval === 'week')
              ? (_openBlock(), _createBlock("div", _hoisted_23, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.knCronDescriptor.weeklyOptions, (day, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _createVNode("span", _hoisted_24, _toDisplayString(day.name + ':'), 1),
                      _createVNode(_component_Checkbox, {
                        value: day.value,
                        modelValue: _ctx.selectedDays,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectedDays = $event)),
                        onClick: _ctx.updateCronDays
                      }, null, 8, ["value", "modelValue", "onClick"])
                    ]))
                  }), 128))
                ]))
              : (_ctx.repeatInterval === 'month')
                ? (_openBlock(), _createBlock("div", _hoisted_25, [
                    _createVNode("div", _hoisted_26, [
                      _createVNode("div", null, [
                        _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('cron.advanced')), 1),
                        _createVNode(_component_InputSwitch, {
                          class: "p-mr-2",
                          modelValue: _ctx.simpleMonth,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.simpleMonth = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode("span", null, _toDisplayString(_ctx.$t('cron.simple')), 1)
                      ]),
                      (_ctx.simpleMonth)
                        ? (_openBlock(), _createBlock("div", _hoisted_28, [
                            _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('kpi.kpiScheduler.every')), 1),
                            _createVNode(_component_Dropdown, {
                              class: "kn-material-input",
                              optionLabel: "name",
                              optionValue: "value",
                              modelValue: _ctx.parameter,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.parameter = $event)),
                              options: _ctx.parameterOptions,
                              onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.updateCronSimpleMonthRepetition(true)))
                            }, null, 8, ["modelValue", "options"]),
                            _createVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('cron.months')), 1)
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_31, [
                            _createVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('cron.inMonth')), 1),
                            _createVNode(_component_MultiSelect, {
                              class: "kn-material-input",
                              optionLabel: "name",
                              optionValue: "value",
                              modelValue: _ctx.selectedMonths,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.selectedMonths = $event)),
                              options: _ctx.parameterOptions,
                              onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateCronAdvancedMonthRepetition(true)))
                            }, null, 8, ["modelValue", "options"])
                          ]))
                    ]),
                    _createVNode("div", _hoisted_33, [
                      _createVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('cron.advanced')), 1),
                      _createVNode(_component_InputSwitch, {
                        class: "p-mr-2",
                        modelValue: _ctx.simpleDay,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.simpleDay = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode("span", null, _toDisplayString(_ctx.$t('cron.simple')), 1),
                      (_ctx.simpleDay)
                        ? (_openBlock(), _createBlock("div", _hoisted_35, [
                            _createVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('cron.theDay')), 1),
                            _createVNode(_component_Dropdown, {
                              class: "kn-material-input",
                              optionLabel: "name",
                              optionValue: "value",
                              modelValue: _ctx.simpleDayParameter,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.simpleDayParameter = $event)),
                              options: _ctx.dayOptions,
                              onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.updateCronSimpleDayRepetition(true)))
                            }, null, 8, ["modelValue", "options"])
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_37, [
                            _createVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('cron.theWeek')), 1),
                            _createVNode(_component_Dropdown, {
                              class: "kn-material-input",
                              style: _ctx.knCronDescriptor.style.advancedDayDropdown,
                              optionLabel: "name",
                              optionValue: "value",
                              modelValue: _ctx.parameterDay,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.parameterDay = $event)),
                              options: _ctx.knCronDescriptor.dayOptions,
                              onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.updateCronAdvancedDayRepetition(true)))
                            }, null, 8, ["style", "modelValue", "options"]),
                            _createVNode("label", _hoisted_39, _toDisplayString(_ctx.$t('cron.inDay')), 1),
                            _createVNode(_component_MultiSelect, {
                              class: "kn-material-input",
                              optionLabel: "name",
                              optionValue: "value",
                              modelValue: _ctx.selectedDays,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.selectedDays = $event)),
                              options: _ctx.knCronDescriptor.weeklyOptions,
                              onChange: _ctx.updateCronAdvancedDayRepetition
                            }, null, 8, ["modelValue", "options", "onChange"])
                          ]))
                    ])
                  ]))
                : _createCommentVNode("", true),
          (_ctx.repeatInterval === 'minute')
            ? (_openBlock(), _createBlock("label", _hoisted_40, _toDisplayString(_ctx.$t('cron.minutes')), 1))
            : (_ctx.repeatInterval === 'hour')
              ? (_openBlock(), _createBlock("label", _hoisted_41, _toDisplayString(_ctx.$t('cron.hours')), 1))
              : (_ctx.repeatInterval === 'day')
                ? (_openBlock(), _createBlock("label", _hoisted_42, _toDisplayString(_ctx.$t('cron.days')), 1))
                : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["style"]))
}